import React, { useContext } from 'react';
import { Redirect } from 'react-router-dom';
import { CommonStore } from 'stores';
import { PATHS } from 'config';
import TrackedRoute from './tracked';
import withTracking from 'tracking/withTracking';
import { parse } from 'query-string';

export default withTracking(({ analytics, ...props }) => {
    const store = useContext(CommonStore);

    if (store.user && !store.loadingUserData) {
        analytics.setRedirectedFrom(props.location.pathname);
        const query = parse(props.location.search);
        const to = query.continue
            ? decodeURIComponent(query.continue)
            : PATHS.dashboard;
        return <Redirect to={to} />;
    }

    return <TrackedRoute {...props} />;
});
